import React from 'react'
import update from 'immutability-helper'

import NavLink from '../Routes/NavLink'

import Space from './Type/Space'
import ExpiringLeases from './Type/ExpiringLeases'
import FinancialBreakdown from './Type/FinancialBreakdown'
import Building from './Type/Building'
import Sensor from './Type/Sensor'
import Integration from './Type/Integration'

import { modal } from '../../core/utilities/modal'

export default class SingleTask extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            minimized: false,
            getDataAgain: false,
            reloadData: false
        }
    }

    componentDidMount() {
		jQuery(jQuery('.single-task-card .scroll-attach')).slimScroll({
            height: '150px',
			alwaysVisible: true
		});
    }

    componentWillUpdate(nextProps, nextState) {
    }

    componentDidUpdate() {
        jQuery(jQuery('.single-task-card .scroll-attach')).slimScroll({
            height: '150px',
			alwaysVisible: true
		});
    }

    minimizeTask(e) {
        this.setState({
            minimized: true
        });
    }
    /**
    *
    * Maximizes SingleTask
    *
    */
    maximizeTask(e) {
        // #  update
        this.setState({
            minimized: false
        });
    }

    render(){
        const type = this.props.type;
        const isMinimized = this.state.minimized;
        const data = this.props.data;

        if(this.props.data === undefined) {
            return (
                <div></div>
            )
        }

        if(!isMinimized) {
            if(type == 'space') {
                return (
                    <div class="col-md-4 single-task-card">
                        <Space data={this.props.data} closeTask={this.props.closeTask} minimizeTask={this.minimizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                )
            } else if(type == 'sensor') {
                return (
                    <div class="col-md-4 single-task-card">
                        <Sensor data={this.props.data} closeTask={this.props.closeTask} minimizeTask={this.minimizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                )
            } else if (type == 'expiringLeases') {
                return (
                    <div class="col-md-4 single-task-card">
                        <ExpiringLeases data={this.props.data} closeTask={this.props.closeTask} minimizeTask={this.minimizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                )
            } else if (type == 'financialBreakdown') {
                return (
                    <div class="col-md-4 single-task-card">
                        <FinancialBreakdown data={this.props.data} closeTask={this.props.closeTask} minimizeTask={this.minimizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                )
            } else if (type == 'showAssociatedBuilding') {
                return (
                    <div class="col-md-4 single-task-card">
                        <Building data={this.props.data} closeTask={this.props.closeTask} minimizeTask={this.minimizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                )
            } else if(type == 'integration') {
                return (
                    <div class="col-md-4 single-task-card">
                        <Integration data={data} closeTask={this.props.closeTask} minimizeTask={this.minimizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                )
            } else {
                return (
                    <div></div>
                )
            }
        } else {
            // # IS MINIMIZED
            if(type == 'space') {
                return (
                    <div class="col-md-4 single-task-card minimized">
                        <Space data={this.props.data} closeTask={this.props.closeTask} maximizeTask={this.maximizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                );
            } else if(type == 'sensor') {
                return (
                    <div class="col-md-4 single-task-card minimized">
                        <Sensor data={this.props.data} closeTask={this.props.closeTask} maximizeTask={this.maximizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                );
            } else if (type == 'expiringLeases') {
                return (
                    <div class="col-md-4 single-task-card minimized">
                        <ExpiringLeases data={this.props.data} closeTask={this.props.closeTask} maximizeTask={this.maximizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                )
            } else if (type == 'financialBreakdown') {
                return (
                    <div class="col-md-4 single-task-card minimized">
                        <FinancialBreakdown data={this.props.data} closeTask={this.props.closeTask} maximizeTask={this.maximizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                )
            } else if (type == 'showAssociatedBuilding') {
                return (
                    <div class="col-md-4 single-task-card">
                        <Building data={this.props.data} closeTask={this.props.closeTask} maximizeTask={this.maximizeTask.bind(this)} type={type} isMinimized={isMinimized} />
                    </div>
                )
            } else {
                return (
                    <div></div>
                )
            }
        }
    }
};


// WEBPACK FOOTER //
// app/components/MultiTaskManager/SingleTask.jsx